<template>
  <!-- 人格测评 -->
  <div class="section">
    <div style="padding-top: 5px">
      <div class="bg1" style="margin: 175px 0 20px 20px">
        <p style="color: #2abdb8; font-weight: bold; padding: 25px 0 0 44px">
          对工作的感知
        </p>
        <p
          style="
            font-size: 10pt;
            padding: 5px 20px 10px 32px;
            margin-top: 20px;
            margin-left: 10px;
            line-height: 19.5px;
          "
        >
          {{ model.workSence }}
        </p>
      </div>

      <!-- <div style="width: 300px; margin: 240px 0 0 65px">
        <p style="font-size: 10pt; padding: 10px; line-height: 19.5px">
          {{ model.workSence }}
        </p>
      </div> -->
      <div class="personalityTraits">
        <personalityTraits :model="model" :result1="result1" />
      </div>

      <div class="bg1" style="margin: 135px 0 20px 20px">
        <p style="color: #2abdb8; font-weight: bold; padding: 25px 0 0 44px">
          工作行为特质
        </p>
        <p
          style="
            font-size: 10pt;
            padding: 5px 20px 10px 32px;
            margin-top: 20px;
            margin-left: 10px;
            line-height: 19.5px;
          "
        >
          {{ model.workBehavioralTraits }}
        </p>
      </div>

      <!-- <div style="width: 295px; margin: 195px 0 0 70px">
        <p style="font-size: 10pt; padding: 0 10px 10px 5px; line-height: 20px">
          {{ model.workBehavioralTraits }}
        </p>
      </div> -->

      <div class="personalityHobby">
        <personalityHobby :model="model" :result1="result1" />
      </div>
    </div>
  </div>
</template>

<script>
import personalityTraits from "@/components/dataView/echarts/personality/personalityTraits.vue";
import personalityHobby from "@/components/dataView/echarts/personality/personalityHobby.vue";
export default {
  props: ["model", "result1"],
  components: { personalityTraits, personalityHobby },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.section {
  page-break-before: always;
  page-break-after: always;
  page-break-inside: avoid;
  height: 1124px; //A4纸的高度像素
  background-size: 100% 100%;
  background-image: url("../../../../assets/images/personality/back11.png");
  overflow: hidden;
  .personalityTraits {
    width: 500px;
    margin-top: -350px;
    margin-left: 250px;
    float: right;
  }
  .personalityHobby {
    width: 500px;
    margin-top: -370px;
    margin-left: 250px;
    float: right;
  }
  .bg1 {
    background-image: url("../../../../assets/images/personality/tu1.png");
    background-size: 100% 100%;
    width: 350px;
    height: 333px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/report/three/personality/pageFour.vue